import React from 'react';

const TextSection = ({ section }) => {
  const sectionData = section.section_data || {};
  const width = sectionData.width || 'full';
  const alignment = sectionData.alignment || 'left';
  const padding = sectionData.padding || 'normal';

  const widthMap = {
    full: '100%',
    narrow: '800px',
    wide: '1200px'
  };

  const paddingMap = {
    none: '0',
    small: '40px 20px',
    normal: '60px 20px',
    large: '80px 20px'
  };

  return (
    <section
      className="text-section"
      style={{
        backgroundColor: section.background_color || '#ffffff',
        color: section.text_color || '#000000',
        padding: paddingMap[padding]
      }}
    >
      <div className="container">
        <div style={{ maxWidth: widthMap[width], margin: '0 auto', textAlign: alignment }}>
          {section.title && (
            <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontWeight: '600' }}>
              {section.title}
            </h2>
          )}
          {section.subtitle && (
            <h3 style={{ fontSize: '1.5rem', marginBottom: '1.5rem', opacity: 0.8, fontWeight: '400' }}>
              {section.subtitle}
            </h3>
          )}
          {section.content && (
            <div
              style={{ fontSize: '1.1rem', lineHeight: '1.8' }}
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default TextSection;
